import { useContext } from 'react';
import { LayoutContext, LayoutContextType } from '../shared/layout/layout';

/**
 * Custom hook to access and use the LayoutContext.
 * This hook provides various functions and state variables to manage the layout of the application.
 *
 * @returns {Object} An object containing functions and state variables for layout management
 */
const useLayoutContext = () => {
  const {
    openSidebar,
    closeSidebar,
    toggleSidebar,
    isSidebarOpen,
    openModal,
    closeModal,
    toggleModal,
    isOpenModal,
    openComingSoon,
    closeComingSoon,
    toggleComingSoon,
    isOpenComingSoon,
    openPageLoad,
    closePageLoad,
    togglePageLoad,
    isOpenPageLoad,
    handleOpenModuleGuide,
    openModuleGuide,
    virtualKeyboard,
  } = useContext(LayoutContext) as LayoutContextType;

  return {
    /** Function to open the sidebar */
    openSidebar,
    /** Function to close the sidebar */
    closeSidebar,
    /** Function to toggle the sidebar open/closed state */
    toggleSidebar,
    /** Boolean indicating whether the sidebar is open */
    isSidebarOpen,
    /** Function to open a modal */
    openModal,
    /** Function to close a modal */
    closeModal,
    /** Function to toggle a modal open/closed state */
    toggleModal,
    /** Boolean indicating whether a modal is open */
    isOpenModal,
    /** Function to open the "Coming Soon" overlay */
    openComingSoon,
    /** Function to close the "Coming Soon" overlay */
    closeComingSoon,
    /** Function to toggle the "Coming Soon" overlay */
    toggleComingSoon,
    /** Boolean indicating whether the "Coming Soon" overlay is open */
    isOpenComingSoon,
    /** Function to open the page load overlay */
    openPageLoad,
    /** Function to close the page load overlay */
    closePageLoad,
    /** Function to toggle the page load overlay */
    togglePageLoad,
    /** Boolean indicating whether the page load overlay is open */
    isOpenPageLoad,
    /** Function to handle opening the module guide */
    handleOpenModuleGuide,
    /** Function to open the module guide */
    openModuleGuide,
    virtualKeyboard,
  };
};

export default useLayoutContext;
